// Default column configuration for Donor table
export const DEFAULT_DONOR_COLUMNS = [
  {
    colId: 'Actions',
    hide: false,
    width: 150,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'id',
    hide: false,
    width: 90,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'donorId',
    hide: false,
    width: 100,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'salutation',
    hide: false,
    width: 90,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'initial',
    hide: false,
    width: 90,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'firstName',
    hide: false,
    width: 150,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'lastName',
    hide: false,
    width: 150,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'address',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'address1',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'address2',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'city',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'state',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'country',
    hide: false,
    width: 110,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'pincode',
    hide: false,
    width: 100,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'panCardNo',
    hide: false,
    width: 180,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'mobile1',
    hide: false,
    width: 120,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'mobile2',
    hide: false,
    width: 120,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'mailId',
    hide: false,
    width: 150,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'status',
    hide: false,
    width: 100,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'prasad',
    hide: false,
    width: 80,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
  {
    colId: 'donorRemarks',
    hide: false,
    width: 150,
    pinned: null,
    sort: null,
    sortIndex: null,
  },
];